module.exports = {
          srcSet: __webpack_public_path__ + "6b368f2e6a73b74bbbfd2175a6e6b2a1-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "6b368f2e6a73b74bbbfd2175a6e6b2a1-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "6b368f2e6a73b74bbbfd2175a6e6b2a1-120.png",
          toString:function(){return __webpack_public_path__ + "6b368f2e6a73b74bbbfd2175a6e6b2a1-120.png"},
          
          width: 120,
          height: 120
        }